import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import { __assign, __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import productGpsrInfoMantenanceList from "./productGpsrInfoMantenanceList.vue";
import productUkComplianceOfficerList from "./productUkComplianceOfficerList.vue";

var ComplianceInfoMaintenancePage = function (_super) {
  __extends(ComplianceInfoMaintenancePage, _super);

  function ComplianceInfoMaintenancePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeTab = "";
    return _this;
  }

  Object.defineProperty(ComplianceInfoMaintenancePage.prototype, "showTabList", {
    get: function get() {
      var tabList = [{
        text: this.tc('商品GPSR信息维护'),
        value: 'productGpsrInfoMantenanceList',
        _permissionKey: "action_product_gpsr_info_mantenance_list"
      }, {
        text: this.tc('商品英国合规负责人维护'),
        value: 'productUkComplianceOfficerList',
        _permissionKey: "action_product_uk_compliance_officer_list"
      }];
      return this.$util.filterListPermission(tabList);
    },
    enumerable: false,
    configurable: true
  });

  ComplianceInfoMaintenancePage.prototype.handleChange = function (value) {
    this.activeTab = value;
    this.$router.push({
      name: 'MaintenanceComplianceOfficerPage',
      query: __assign(__assign({}, this.$route.query), {
        pageType: value
      })
    });
  };

  ComplianceInfoMaintenancePage.prototype.handleSwitchTab = function (componentName) {
    this.activeTab = componentName;
  };

  ComplianceInfoMaintenancePage.prototype.updateSearchList = function () {
    this.$refs.activeComponent && this.$refs.activeComponent.updateSearchList();
  };

  ComplianceInfoMaintenancePage.prototype.created = function () {
    var pageType = this.$route.query.pageType;
    var tabList = this.showTabList.filter(function (item) {
      return item.value === pageType;
    });
    this.activeTab = tabList.length ? tabList[0].value.toString() : this.showTabList[0].value.toString();
  };

  ComplianceInfoMaintenancePage = __decorate([Component({
    components: {
      productGpsrInfoMantenanceList: productGpsrInfoMantenanceList,
      productUkComplianceOfficerList: productUkComplianceOfficerList
    }
  })], ComplianceInfoMaintenancePage);
  return ComplianceInfoMaintenancePage;
}(Vue);

export default ComplianceInfoMaintenancePage;